import CreditChip from './CreditChip';

export default CreditChip;
